import { NgModule, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

import {} from './app-alert';

import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { ModelPropertyViewComponent } from './model-property-view/model-property-view.component';
import { EnvironmentSwitcherComponent } from './environment-switcher/environment-switcher.component';

@NgModule({
  declarations: [
    ConfirmModalComponent,
    ModelPropertyViewComponent,
    EnvironmentSwitcherComponent
  ],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    FormsModule,
    ButtonsModule
  ],
  exports: [
    ConfirmModalComponent,
    ModelPropertyViewComponent,
    EnvironmentSwitcherComponent
  ]
})
export class SharedComponentsModule { }
